function CompanyDetailSidebar({ details }) {
  return (
    <div className="bg-light rounded p-5 wow slideInUp" data-wow-delay="0.1s">
      <h4 className="mb-4">Company Detail</h4>
      <p className="m-0" style={style.prewrap}>
        {details.companyDetails}
      </p>
    </div>
  );
}

const style = {
  prewrap: { whiteSpace: "pre-wrap" },
};

export default CompanyDetailSidebar;
